<template>
  <prismic-rich-text class="slice-richtext content is-custom mb-24px" :field="fragment.primary.richtext_content" />
</template>

<script>
export default {
  props: {
    fragment: Object
  }
}
</script>

<style lang="scss">
.slice-richtext {
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 1.5em;
  }

  &:first-child > :first-child {
    margin-top: 0;
  }
}
</style>